import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE OUTSIDE (ONLY CHANGE)
function loadAllWorks() {
    $.ajax({
        url: `${API_BASE_URL}/api/work/all`,
        type: "GET",
        success: function (works) {
            works.reverse();
            let rows = "";
            works.forEach((work, index) => {
                rows += `
                    <tr>
                        <td>${index + 1}</td>
                        <td><img src="${API_BASE_URL}/assets/Images/${work.image}" width="80" height="80" /></td>
                        <td>${work.name}</td>
                        <td>${work.description}</td>
                        <td>
                            <button class="btn btn-primary btn-sm editWorkBtn mb-2 w-100" data-id="${work.id}">Edit</button>
                            <button class="btn btn-danger btn-sm mx-1 deleteWorkBtn b-2 w-100" data-id="${work.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });
            $("#allWorksData").html(rows);
        },
        error: function (xhr) {
            console.error("Failed to fetch works", xhr);
        }
    });
}

// ✅ KEEP SAME
window.loadWorks = function () {
    loadAllWorks();
};

$(document).ready(function () {

    // Add Work
    $("#addWorkForm").submit(function (e) {
        e.preventDefault();
        const formData = new FormData();
        formData.append("name", $("#name").val());
        formData.append("description", $("#discription").val());
        formData.append("image", $("#image")[0].files[0]);

        $.ajax({
            url: `${API_BASE_URL}/api/work/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function () {
                showSuccessModal("Work Added Successfully!");
                $("#addWorkForm")[0].reset();

                const workModal = window.bootstrap.Modal.getInstance(document.getElementById("workModal"));
                workModal.hide();

                loadAllWorks(); 
            },
            error: function (xhr) {
                console.log(xhr);
                alert("Failed to add Work!");
            }
        });
    });

    // OPEN EDIT MODAL
    $(document).on("click", ".editWorkBtn", function () {
        const id = $(this).data("id");

        $.ajax({
            url: `${API_BASE_URL}/api/work/get/${id}`,
            type: "GET",
            success: function (b) {

                $("#editId").val(b.id);
                $("#editName").val(b.name);
                $("#editDescription").val(b.description);

                new window.bootstrap.Modal(document.getElementById("editWorkModal")).show();
            },
            error: () => alert("Failed to fetch work data")
        });
    });

    // UPDATE Work
    $("#editWorkForm").submit(function (e) {
        e.preventDefault();

        const id = $("#editId").val();
        const formData = new FormData();

        formData.append("name", $("#editName").val());
        formData.append("description", $("#editDescription").val());

        if ($("#editImage")[0].files.length > 0) {
            formData.append("image", $("#editImage")[0].files[0]);
        }

        $.ajax({
            url: `${API_BASE_URL}/api/work/update/${id}`,
            type: "POST",
            contentType: false,
            processData: false,
            data: formData,
            success: function () {
                showSuccessModal("Work Updated Successfully!");
                loadAllWorks();

                const editModal = window.bootstrap.Modal.getInstance(document.getElementById("editWorkModal"));
                editModal.hide();
            },
            error: () => alert("Failed to update work")
        });
    });

    // Delete Work
    $(document).on("click", ".deleteWorkBtn", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure you want to delete this Work?")) {
            return;
        }

        $.ajax({
            url: `${API_BASE_URL}/api/work/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Work Delete Successfully!");
                loadAllWorks();
            },
            error: function (xhr) {
                console.error(xhr);
                alert("Failed to delete work!");
            }
        });
    });

});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadWorks = function () {
//     loadAllWorks();
// };

// $(document).ready(function () {

//     // Add Work
//     $("#addWorkForm").submit(function (e) {
//         e.preventDefault();
//         const formData = new FormData();
//         formData.append("name", $("#name").val());
//         formData.append("description", $("#discription").val());
//         formData.append("image", $("#image")[0].files[0]);
//         $.ajax({
//             url: `${API_BASE_URL}/api/work/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Work Added Successfully!");
//                 $("#addWorkForm")[0].reset();
//                 // Close Work Modal
//                 const workModal = window.bootstrap.Modal.getInstance(document.getElementById("workModal"));
//                 workModal.hide();

//                 loadAllWorks(); 
//             },
//             error: function (xhr) {
//                 console.log(xhr);
//                 alert("Failed to add Work!");
//             }
//         });
//     });

//     // Get All Work
//     function loadAllWorks() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/work/all`,
//             type: "GET",
//             success: function (works) {
//                 works.reverse();
//                 let rows = "";
//                 works.forEach((work, index) => {
//                     rows += `
//                         <tr>
//                             <td>${index + 1}</td>
//                             <td><img src="${API_BASE_URL}/assets/Images/${work.image}" width="80" height="80" /></td>
//                             <td>${work.name}</td>
//                             <td>${work.description}</td>
//                             <td>
//                                 <button class="btn btn-primary btn-sm editWorkBtn mb-2 w-100" data-id="${work.id}">Edit</button>
//                                 <button class="btn btn-danger btn-sm mx-1 deleteWorkBtn b-2 w-100" data-id="${work.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });
//                 $("#allWorksData").html(rows);
//             },
//             error: function (xhr) {
//                 console.error("Failed to fetch works", xhr);
//             }
//         });
//     }

//     // OPEN EDIT MODAL
//     $(document).on("click", ".editWorkBtn", function () {
//         const id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/work/get/${id}`,
//             type: "GET",
//             success: function (b) {

//                 $("#editId").val(b.id);
//                 $("#editName").val(b.name);
//                 $("#editDescription").val(b.description);

//                 new window.bootstrap.Modal(document.getElementById("editWorkModal")).show();
//             },
//             error: () => alert("Failed to fetch work data")
//         });
//     });

//     // UPDATE Work
//     $("#editWorkForm").submit(function (e) {
//         e.preventDefault();

//         const id = $("#editId").val();
//         const formData = new FormData();

//         formData.append("name", $("#editName").val());
//         formData.append("description", $("#editDescription").val());

//         if ($("#editImage")[0].files.length > 0) {
//             formData.append("image", $("#editImage")[0].files[0]);
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/work/update/${id}`,
//             type: "POST",
//             contentType: false,
//             processData: false,
//             data: formData,
//             success: function () {
//                 showSuccessModal("Work Updated Successfully!");
//                 loadAllWorks();

//                 const editModal = window.bootstrap.Modal.getInstance(document.getElementById("editWorkModal"));
//                 editModal.hide();
//             },
//             error: () => alert("Failed to update work")
//         });
//     });

//     // Delete Work
//     $(document).on("click", ".deleteWorkBtn", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure you want to delete this Work?")) {
//             return;
//         }

//         $.ajax({
//             url: `${API_BASE_URL}/api/work/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Work Delete Successfully!");
//                 loadAllWorks();
//             },
//             error: function (xhr) {
//                 console.error(xhr);
//                 alert("Failed to delete work!");
//             }
//         });
//     });

// });